import { toast } from "@/components/ui/use-toast";
import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const CREATE_PAYMENT_ACCOUNT_ONBOARD_URL = gql(`
  mutation CREATE_PAYMENT_ACCOUNT_ONBOARD_URL($organizationSlug: String!) {
    paymentAccountOnboardURLCreate(organizationSlug: $organizationSlug) {
      ... on PaymentAccountURL {
        url
      }
      ... on PaymentAccountNotFound {
        organizationID
      }
    }
  }
`);

type Props = {
  organizationSlug: string;
};

export function useCreatePaymentAccountOnboardURL({ organizationSlug }: Props) {
  const [createPaymentAccountOnboardURL, { loading }] = useMutation(
    CREATE_PAYMENT_ACCOUNT_ONBOARD_URL,
    {
      variables: { organizationSlug }
    }
  );

  const handleOpenPaymentOnboarding = async () => {
    const { data } = await createPaymentAccountOnboardURL();
    switch (data?.paymentAccountOnboardURLCreate.__typename) {
      case "PaymentAccountURL":
        return window.open(data.paymentAccountOnboardURLCreate.url);
      case "PaymentAccountNotFound":
        return toast({
          title: "Payment account not found",
          description:
            "There was an error setting up your payment account. Please reach out to the Numerous team to resolve this."
        });
      default:
        return null;
    }
  };

  return {
    handleOpenPaymentOnboarding,
    createPaymentAccountOnboardURL,
    loading
  };
}
